import {requestWithToken} from "../apiConfigs/request";

export const fetchAppliedJobsList = (query) => {
  return requestWithToken({
    url: `/applied-jobs${query}`,
    method: 'GET'
  });
}

export const converToCandidates = (data) => {
  return requestWithToken({
    url: `/applied-jobs/convert-to-candidates`,
    method: 'POST',
    data
  });
}
